/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BillingAccountData,
    BillingAccountDataFromJSON,
    BillingAccountDataToJSON,
} from '../models/BillingAccountData';
import {
    type BillingAccountInput,
    BillingAccountInputFromJSON,
    BillingAccountInputToJSON,
} from '../models/BillingAccountInput';
import {
    type CardData,
    CardDataFromJSON,
    CardDataToJSON,
} from '../models/CardData';
import {
    type ChannelOverview,
    ChannelOverviewFromJSON,
    ChannelOverviewToJSON,
} from '../models/ChannelOverview';
import {
    type CreateOrUpdateProjectDomainInput,
    CreateOrUpdateProjectDomainInputFromJSON,
    CreateOrUpdateProjectDomainInputToJSON,
} from '../models/CreateOrUpdateProjectDomainInput';
import {
    type CreateOtherSystemSourceInput,
    CreateOtherSystemSourceInputFromJSON,
    CreateOtherSystemSourceInputToJSON,
} from '../models/CreateOtherSystemSourceInput';
import {
    type CreateOtherSystemSourceInsightInput,
    CreateOtherSystemSourceInsightInputFromJSON,
    CreateOtherSystemSourceInsightInputToJSON,
} from '../models/CreateOtherSystemSourceInsightInput';
import {
    type CreateRoleInput,
    CreateRoleInputFromJSON,
    CreateRoleInputToJSON,
} from '../models/CreateRoleInput';
import {
    type DeleteOtherSystemSourceInsightInput,
    DeleteOtherSystemSourceInsightInputFromJSON,
    DeleteOtherSystemSourceInsightInputToJSON,
} from '../models/DeleteOtherSystemSourceInsightInput';
import {
    type DeleteProjectDomainInput,
    DeleteProjectDomainInputFromJSON,
    DeleteProjectDomainInputToJSON,
} from '../models/DeleteProjectDomainInput';
import {
    type ErpFilter,
    ErpFilterFromJSON,
    ErpFilterToJSON,
} from '../models/ErpFilter';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type HostNameAndCsvLinkData,
    HostNameAndCsvLinkDataFromJSON,
    HostNameAndCsvLinkDataToJSON,
} from '../models/HostNameAndCsvLinkData';
import {
    type HostNameAndTldAndApiCurrencyCodeCredentialData,
    HostNameAndTldAndApiCurrencyCodeCredentialDataFromJSON,
    HostNameAndTldAndApiCurrencyCodeCredentialDataToJSON,
} from '../models/HostNameAndTldAndApiCurrencyCodeCredentialData';
import {
    type HostNameAndXmlLinkData,
    HostNameAndXmlLinkDataFromJSON,
    HostNameAndXmlLinkDataToJSON,
} from '../models/HostNameAndXmlLinkData';
import {
    type HostNameApiIdCredentialData,
    HostNameApiIdCredentialDataFromJSON,
    HostNameApiIdCredentialDataToJSON,
} from '../models/HostNameApiIdCredentialData';
import {
    type InviteUserInput,
    InviteUserInputFromJSON,
    InviteUserInputToJSON,
} from '../models/InviteUserInput';
import {
    type InvoiceListData,
    InvoiceListDataFromJSON,
    InvoiceListDataToJSON,
} from '../models/InvoiceListData';
import {
    type MarketingChannelList,
    MarketingChannelListFromJSON,
    MarketingChannelListToJSON,
} from '../models/MarketingChannelList';
import {
    type MarketingChannelOverviewCollectionData,
    MarketingChannelOverviewCollectionDataFromJSON,
    MarketingChannelOverviewCollectionDataToJSON,
} from '../models/MarketingChannelOverviewCollectionData';
import {
    type ModifyOtherSystemSourceInput,
    ModifyOtherSystemSourceInputFromJSON,
    ModifyOtherSystemSourceInputToJSON,
} from '../models/ModifyOtherSystemSourceInput';
import {
    type ModifyOtherSystemSourceInsightInput,
    ModifyOtherSystemSourceInsightInputFromJSON,
    ModifyOtherSystemSourceInsightInputToJSON,
} from '../models/ModifyOtherSystemSourceInsightInput';
import {
    type OtherSystemSourceInsight,
    OtherSystemSourceInsightFromJSON,
    OtherSystemSourceInsightToJSON,
} from '../models/OtherSystemSourceInsight';
import {
    type OtherSystemSourceWithCentreAndDomain,
    OtherSystemSourceWithCentreAndDomainFromJSON,
    OtherSystemSourceWithCentreAndDomainToJSON,
} from '../models/OtherSystemSourceWithCentreAndDomain';
import {
    type OtherSystemType,
    OtherSystemTypeFromJSON,
    OtherSystemTypeToJSON,
} from '../models/OtherSystemType';
import {
    type PatchRoleInput,
    PatchRoleInputFromJSON,
    PatchRoleInputToJSON,
} from '../models/PatchRoleInput';
import {
    type PaymentSetupData,
    PaymentSetupDataFromJSON,
    PaymentSetupDataToJSON,
} from '../models/PaymentSetupData';
import {
    type ProjectBillingAccountInput,
    ProjectBillingAccountInputFromJSON,
    ProjectBillingAccountInputToJSON,
} from '../models/ProjectBillingAccountInput';
import {
    type ProjectCentreWithDomains,
    ProjectCentreWithDomainsFromJSON,
    ProjectCentreWithDomainsToJSON,
} from '../models/ProjectCentreWithDomains';
import {
    type ProjectData,
    ProjectDataFromJSON,
    ProjectDataToJSON,
} from '../models/ProjectData';
import {
    type ProjectDomainAdditionalPaymentData,
    ProjectDomainAdditionalPaymentDataFromJSON,
    ProjectDomainAdditionalPaymentDataToJSON,
} from '../models/ProjectDomainAdditionalPaymentData';
import {
    type ProjectDomainWithStats,
    ProjectDomainWithStatsFromJSON,
    ProjectDomainWithStatsToJSON,
} from '../models/ProjectDomainWithStats';
import {
    type ProjectDomainsLimitOutput,
    ProjectDomainsLimitOutputFromJSON,
    ProjectDomainsLimitOutputToJSON,
} from '../models/ProjectDomainsLimitOutput';
import {
    type ProjectInput,
    ProjectInputFromJSON,
    ProjectInputToJSON,
} from '../models/ProjectInput';
import {
    type ProjectInvitation,
    ProjectInvitationFromJSON,
    ProjectInvitationToJSON,
} from '../models/ProjectInvitation';
import {
    type ProjectOrderStatusSettings,
    ProjectOrderStatusSettingsFromJSON,
    ProjectOrderStatusSettingsToJSON,
} from '../models/ProjectOrderStatusSettings';
import {
    type ProjectRole,
    ProjectRoleFromJSON,
    ProjectRoleToJSON,
} from '../models/ProjectRole';
import {
    type ProjectRoleOutput,
    ProjectRoleOutputFromJSON,
    ProjectRoleOutputToJSON,
} from '../models/ProjectRoleOutput';
import {
    type ProjectRuntimeOverview,
    ProjectRuntimeOverviewFromJSON,
    ProjectRuntimeOverviewToJSON,
} from '../models/ProjectRuntimeOverview';
import {
    type ProjectStatusUpdate,
    ProjectStatusUpdateFromJSON,
    ProjectStatusUpdateToJSON,
} from '../models/ProjectStatusUpdate';
import {
    type ProjectUsers200Response,
    ProjectUsers200ResponseFromJSON,
    ProjectUsers200ResponseToJSON,
} from '../models/ProjectUsers200Response';
import {
    type RemoveUserInput,
    RemoveUserInputFromJSON,
    RemoveUserInputToJSON,
} from '../models/RemoveUserInput';
import {
    type SetOwnerInput,
    SetOwnerInputFromJSON,
    SetOwnerInputToJSON,
} from '../models/SetOwnerInput';
import {
    type SetRoleInput,
    SetRoleInputFromJSON,
    SetRoleInputToJSON,
} from '../models/SetRoleInput';
import {
    type SingleCampaignOverview,
    SingleCampaignOverviewFromJSON,
    SingleCampaignOverviewToJSON,
} from '../models/SingleCampaignOverview';
import {
    type UpdateSubscriptionInput,
    UpdateSubscriptionInputFromJSON,
    UpdateSubscriptionInputToJSON,
} from '../models/UpdateSubscriptionInput';

export interface ProjectApiChangeBillingAccountRequest {
    projectId: string;
    billingAccountInput?: BillingAccountInput;
}

export interface ProjectApiCreateOrUpdateProjectDomainRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: CreateOrUpdateProjectDomainInput;
}

export interface ProjectApiCreateOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    createOtherSystemSourceInput?: CreateOtherSystemSourceInput;
}

export interface ProjectApiCreateOtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    createOtherSystemSourceInsightInput?: CreateOtherSystemSourceInsightInput;
}

export interface ProjectApiCreateProjectRequest {
    projectInput?: ProjectInput;
}

export interface ProjectApiCreateProjectRoleRequest {
    projectId: string;
    createRoleInput?: CreateRoleInput;
}

export interface ProjectApiDeleteOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
}

export interface ProjectApiDeleteOtherSystemSourceInsightRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    deleteOtherSystemSourceInsightInput?: DeleteOtherSystemSourceInsightInput;
}

export interface ProjectApiDeleteProjectRequest {
    projectId: string;
}

export interface ProjectApiDeleteProjectDomainRequest {
    projectId: string;
    deleteProjectDomainInput?: DeleteProjectDomainInput;
}

export interface ProjectApiDeleteProjectInviteRequest {
    projectId: string;
    inviteId: string;
}

export interface ProjectApiDeleteProjectRoleRequest {
    projectId: string;
    roleId: string;
}

export interface ProjectApiGetDomainsStatusChangePriceRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: Array<CreateOrUpdateProjectDomainInput>;
}

export interface ProjectApiGetPaymentMethodRequest {
    projectId: string;
    updateSubscriptionInput?: UpdateSubscriptionInput;
}

export interface ProjectApiGetProjectDomainsLimitRequest {
    projectId: string;
}

export interface ProjectApiGetProjectRoleRequest {
    projectId: string;
    roleId: string;
}

export interface ProjectApiHostNameAndCSVLinkRequest {
    integrationId: string;
}

export interface ProjectApiHostNameAndTLDAndApiKeyRequest {
    integrationId: string;
}

export interface ProjectApiHostNameAndXMLLinkRequest {
    integrationId: string;
}

export interface ProjectApiHostNameApiIdApiKeyRequest {
    integrationId: string;
}

export interface ProjectApiIntegrationWorkerURLRequest {
    integrationId: string;
}

export interface ProjectApiInviteUserRequest {
    projectId: string;
    inviteUserInput?: InviteUserInput;
}

export interface ProjectApiListProjectCentresRequest {
    projectId: string;
}

export interface ProjectApiListProjectDomainsRequest {
    projectId: string;
}

export interface ProjectApiListProjectInvoicesRequest {
    projectId: string;
    startingAfter?: string;
}

export interface ProjectApiMarketingChannelCampaignDataRequest {
    projectId: string;
    channelId: string;
    campaignRemoteId: string;
    erpFilter?: ErpFilter;
}

export interface ProjectApiMarketingChannelDataRequest {
    projectId: string;
    channelId: string;
    erpFilter?: ErpFilter;
}

export interface ProjectApiMarketingChannelOverviewsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ProjectApiMarketingChannelsRequest {
    projectId: string;
}

export interface ProjectApiModifyOrderStatusListRequest {
    projectId: string;
    projectStatusUpdate?: ProjectStatusUpdate;
}

export interface ProjectApiModifyOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    modifyOtherSystemSourceInput?: ModifyOtherSystemSourceInput;
}

export interface ProjectApiModifyOtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    modifyOtherSystemSourceInsightInput?: ModifyOtherSystemSourceInsightInput;
}

export interface ProjectApiNewPaymentSetupRequest {
    projectId: string;
}

export interface ProjectApiOrderStatusListRequest {
    projectId: string;
}

export interface ProjectApiOtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
}

export interface ProjectApiOtherSystemSourcesRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
}

export interface ProjectApiPatchProjectRoleRequest {
    projectId: string;
    roleId: string;
    patchRoleInput?: PatchRoleInput;
}

export interface ProjectApiProjectInvitesRequest {
    projectId: string;
}

export interface ProjectApiProjectRolesRequest {
    projectId: string;
}

export interface ProjectApiProjectStatusRequest {
    projectId: string;
}

export interface ProjectApiProjectUsersRequest {
    projectId: string;
    page?: number;
    pageSize?: ProjectUsersPageSizeEnum;
    searchTerm?: string;
    sortBy?: ProjectUsersSortByEnum;
    sortDirection?: ProjectUsersSortDirectionEnum;
}

export interface ProjectApiRemoveProjectUserRequest {
    projectId: string;
    removeUserInput?: RemoveUserInput;
}

export interface ProjectApiResendProjectInviteRequest {
    projectId: string;
    inviteId: string;
}

export interface ProjectApiSetProjectBillingAccountRequest {
    projectId: string;
    projectBillingAccountInput?: ProjectBillingAccountInput;
}

export interface ProjectApiTouchProjectRequest {
    projectId: string;
}

export interface ProjectApiUpdateProjectRequest {
    projectId: string;
    projectInput?: ProjectInput;
}

export interface ProjectApiUpdateProjectDomainsStatusRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: Array<CreateOrUpdateProjectDomainInput>;
}

export interface ProjectApiUpdateProjectOwnerRequest {
    projectId: string;
    userId: string;
    setOwnerInput?: SetOwnerInput;
}

export interface ProjectApiUpdateProjectRoleRequest {
    projectId: string;
    userId: string;
    setRoleInput?: SetRoleInput;
}

export interface ProjectApiUploadLogoRequest {
    projectId: string;
    logo?: Blob;
}

/**
 * 
 */
export class ProjectApi extends runtime.BaseAPI {

    /**
     * Creates request options for changeBillingAccount without sending the request
     */
    async changeBillingAccountRequestOpts(requestParameters: ProjectApiChangeBillingAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling changeBillingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/billing-account`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillingAccountInputToJSON(requestParameters['billingAccountInput']),
        };
    }

    /**
     * Change project\'s billing account.
     */
    async changeBillingAccountRaw(requestParameters: ProjectApiChangeBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingAccountData>> {
        const requestOptions = await this.changeBillingAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingAccountDataFromJSON(jsonValue));
    }

    /**
     * Change project\'s billing account.
     */
    async changeBillingAccount(requestParameters: ProjectApiChangeBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingAccountData> {
        const response = await this.changeBillingAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrUpdateProjectDomain without sending the request
     */
    async createOrUpdateProjectDomainRequestOpts(requestParameters: ProjectApiCreateOrUpdateProjectDomainRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOrUpdateProjectDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateProjectDomainInputToJSON(requestParameters['createOrUpdateProjectDomainInput']),
        };
    }

    /**
     * Creates or updates projects by host name.
     */
    async createOrUpdateProjectDomainRaw(requestParameters: ProjectApiCreateOrUpdateProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOrUpdateProjectDomainRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates or updates projects by host name.
     */
    async createOrUpdateProjectDomain(requestParameters: ProjectApiCreateOrUpdateProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOrUpdateProjectDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOtherSystemSource without sending the request
     */
    async createOtherSystemSourceRequestOpts(requestParameters: ProjectApiCreateOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling createOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOtherSystemSourceInputToJSON(requestParameters['createOtherSystemSourceInput']),
        };
    }

    /**
     * Creates new source.
     */
    async createOtherSystemSourceRaw(requestParameters: ProjectApiCreateOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates new source.
     */
    async createOtherSystemSource(requestParameters: ProjectApiCreateOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOtherSystemSourceInsights without sending the request
     */
    async createOtherSystemSourceInsightsRequestOpts(requestParameters: ProjectApiCreateOtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOtherSystemSourceInsightInputToJSON(requestParameters['createOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Creates new insight.
     */
    async createOtherSystemSourceInsightsRaw(requestParameters: ProjectApiCreateOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOtherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates new insight.
     */
    async createOtherSystemSourceInsights(requestParameters: ProjectApiCreateOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOtherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createProject without sending the request
     */
    async createProjectRequestOpts(requestParameters: ProjectApiCreateProjectRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectInputToJSON(requestParameters['projectInput']),
        };
    }

    /**
     * Creates a project owned by the currently authenticated user.
     */
    async createProjectRaw(requestParameters: ProjectApiCreateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.createProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Creates a project owned by the currently authenticated user.
     */
    async createProject(requestParameters: ProjectApiCreateProjectRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.createProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createProjectRole without sending the request
     */
    async createProjectRoleRequestOpts(requestParameters: ProjectApiCreateProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/role`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoleInputToJSON(requestParameters['createRoleInput']),
        };
    }

    /**
     * Creates a role.
     */
    async createProjectRoleRaw(requestParameters: ProjectApiCreateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.createProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates a role.
     */
    async createProjectRole(requestParameters: ProjectApiCreateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.createProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOtherSystemSource without sending the request
     */
    async deleteOtherSystemSourceRequestOpts(requestParameters: ProjectApiDeleteOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/source/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes existing source.
     */
    async deleteOtherSystemSourceRaw(requestParameters: ProjectApiDeleteOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes existing source.
     */
    async deleteOtherSystemSource(requestParameters: ProjectApiDeleteOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOtherSystemSourceInsight without sending the request
     */
    async deleteOtherSystemSourceInsightRequestOpts(requestParameters: ProjectApiDeleteOtherSystemSourceInsightRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteOtherSystemSourceInsightInputToJSON(requestParameters['deleteOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Deletes existing insight.
     */
    async deleteOtherSystemSourceInsightRaw(requestParameters: ProjectApiDeleteOtherSystemSourceInsightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteOtherSystemSourceInsightRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes existing insight.
     */
    async deleteOtherSystemSourceInsight(requestParameters: ProjectApiDeleteOtherSystemSourceInsightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteOtherSystemSourceInsightRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProject without sending the request
     */
    async deleteProjectRequestOpts(requestParameters: ProjectApiDeleteProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes the project.
     */
    async deleteProjectRaw(requestParameters: ProjectApiDeleteProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes the project.
     */
    async deleteProject(requestParameters: ProjectApiDeleteProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectDomain without sending the request
     */
    async deleteProjectDomainRequestOpts(requestParameters: ProjectApiDeleteProjectDomainRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteProjectDomainInputToJSON(requestParameters['deleteProjectDomainInput']),
        };
    }

    /**
     * Returns list of project domains.
     */
    async deleteProjectDomainRaw(requestParameters: ProjectApiDeleteProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectDomainRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns list of project domains.
     */
    async deleteProjectDomain(requestParameters: ProjectApiDeleteProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectInvite without sending the request
     */
    async deleteProjectInviteRequestOpts(requestParameters: ProjectApiDeleteProjectInviteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectInvite().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling deleteProjectInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invite/{inviteId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{inviteId}', encodeURIComponent(String(requestParameters['inviteId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all the invites available on this project.
     */
    async deleteProjectInviteRaw(requestParameters: ProjectApiDeleteProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns all the invites available on this project.
     */
    async deleteProjectInvite(requestParameters: ProjectApiDeleteProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectRole without sending the request
     */
    async deleteProjectRoleRequestOpts(requestParameters: ProjectApiDeleteProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling deleteProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes a role.
     */
    async deleteProjectRoleRaw(requestParameters: ProjectApiDeleteProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.deleteProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deletes a role.
     */
    async deleteProjectRole(requestParameters: ProjectApiDeleteProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.deleteProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDomainsStatusChangePrice without sending the request
     */
    async getDomainsStatusChangePriceRequestOpts(requestParameters: ProjectApiGetDomainsStatusChangePriceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getDomainsStatusChangePrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains/status/price`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOrUpdateProjectDomainInput']!.map(CreateOrUpdateProjectDomainInputToJSON),
        };
    }

    /**
     * Find out if an additional payment is needed to change domain statuses
     */
    async getDomainsStatusChangePriceRaw(requestParameters: ProjectApiGetDomainsStatusChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDomainAdditionalPaymentData>> {
        const requestOptions = await this.getDomainsStatusChangePriceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDomainAdditionalPaymentDataFromJSON(jsonValue));
    }

    /**
     * Find out if an additional payment is needed to change domain statuses
     */
    async getDomainsStatusChangePrice(requestParameters: ProjectApiGetDomainsStatusChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDomainAdditionalPaymentData> {
        const response = await this.getDomainsStatusChangePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethod without sending the request
     */
    async getPaymentMethodRequestOpts(requestParameters: ProjectApiGetPaymentMethodRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/payment-method`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionInputToJSON(requestParameters['updateSubscriptionInput']),
        };
    }

    /**
     * Get payment method from Stripe Customer by customer ID.
     */
    async getPaymentMethodRaw(requestParameters: ProjectApiGetPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CardData>> {
        const requestOptions = await this.getPaymentMethodRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardDataFromJSON(jsonValue));
    }

    /**
     * Get payment method from Stripe Customer by customer ID.
     */
    async getPaymentMethod(requestParameters: ProjectApiGetPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CardData> {
        const response = await this.getPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectDomainsLimit without sending the request
     */
    async getProjectDomainsLimitRequestOpts(requestParameters: ProjectApiGetProjectDomainsLimitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectDomainsLimit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/domains/limit`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the effective project domain limit.
     */
    async getProjectDomainsLimitRaw(requestParameters: ProjectApiGetProjectDomainsLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDomainsLimitOutput>> {
        const requestOptions = await this.getProjectDomainsLimitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDomainsLimitOutputFromJSON(jsonValue));
    }

    /**
     * Returns the effective project domain limit.
     */
    async getProjectDomainsLimit(requestParameters: ProjectApiGetProjectDomainsLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDomainsLimitOutput> {
        const response = await this.getProjectDomainsLimitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectRole without sending the request
     */
    async getProjectRoleRequestOpts(requestParameters: ProjectApiGetProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling getProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns single role.
     */
    async getProjectRoleRaw(requestParameters: ProjectApiGetProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectRoleOutput>> {
        const requestOptions = await this.getProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectRoleOutputFromJSON(jsonValue));
    }

    /**
     * Returns single role.
     */
    async getProjectRole(requestParameters: ProjectApiGetProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectRoleOutput> {
        const response = await this.getProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndCSVLink without sending the request
     */
    async hostNameAndCSVLinkRequestOpts(requestParameters: ProjectApiHostNameAndCSVLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndCSVLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-csv-link`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname and CSV link list.
     */
    async hostNameAndCSVLinkRaw(requestParameters: ProjectApiHostNameAndCSVLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndCsvLinkData>>> {
        const requestOptions = await this.hostNameAndCSVLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndCsvLinkDataFromJSON));
    }

    /**
     * Get integration hostname and CSV link list.
     */
    async hostNameAndCSVLink(requestParameters: ProjectApiHostNameAndCSVLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndCsvLinkData>> {
        const response = await this.hostNameAndCSVLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndTLDAndApiKey without sending the request
     */
    async hostNameAndTLDAndApiKeyRequestOpts(requestParameters: ProjectApiHostNameAndTLDAndApiKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndTLDAndApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-tld-and-api-key`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname, tld and api key list.
     */
    async hostNameAndTLDAndApiKeyRaw(requestParameters: ProjectApiHostNameAndTLDAndApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndTldAndApiCurrencyCodeCredentialData>>> {
        const requestOptions = await this.hostNameAndTLDAndApiKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndTldAndApiCurrencyCodeCredentialDataFromJSON));
    }

    /**
     * Get integration hostname, tld and api key list.
     */
    async hostNameAndTLDAndApiKey(requestParameters: ProjectApiHostNameAndTLDAndApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndTldAndApiCurrencyCodeCredentialData>> {
        const response = await this.hostNameAndTLDAndApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndXMLLink without sending the request
     */
    async hostNameAndXMLLinkRequestOpts(requestParameters: ProjectApiHostNameAndXMLLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndXMLLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-xml-link`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname and XML link list.
     */
    async hostNameAndXMLLinkRaw(requestParameters: ProjectApiHostNameAndXMLLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndXmlLinkData>>> {
        const requestOptions = await this.hostNameAndXMLLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndXmlLinkDataFromJSON));
    }

    /**
     * Get integration hostname and XML link list.
     */
    async hostNameAndXMLLink(requestParameters: ProjectApiHostNameAndXMLLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndXmlLinkData>> {
        const response = await this.hostNameAndXMLLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameApiIdApiKey without sending the request
     */
    async hostNameApiIdApiKeyRequestOpts(requestParameters: ProjectApiHostNameApiIdApiKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameApiIdApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-api-id-api-key`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname, apiId and apiKey list.
     */
    async hostNameApiIdApiKeyRaw(requestParameters: ProjectApiHostNameApiIdApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameApiIdCredentialData>>> {
        const requestOptions = await this.hostNameApiIdApiKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameApiIdCredentialDataFromJSON));
    }

    /**
     * Get integration hostname, apiId and apiKey list.
     */
    async hostNameApiIdApiKey(requestParameters: ProjectApiHostNameApiIdApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameApiIdCredentialData>> {
        const response = await this.hostNameApiIdApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for integrationWorkerURL without sending the request
     */
    async integrationWorkerURLRequestOpts(requestParameters: ProjectApiIntegrationWorkerURLRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling integrationWorkerURL().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/worker-url`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get URL of integration worker.
     */
    async integrationWorkerURLRaw(requestParameters: ProjectApiIntegrationWorkerURLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectUsers200Response>> {
        const requestOptions = await this.integrationWorkerURLRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get URL of integration worker.
     */
    async integrationWorkerURL(requestParameters: ProjectApiIntegrationWorkerURLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectUsers200Response> {
        const response = await this.integrationWorkerURLRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for inviteUser without sending the request
     */
    async inviteUserRequestOpts(requestParameters: ProjectApiInviteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling inviteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/invite`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteUserInputToJSON(requestParameters['inviteUserInput']),
        };
    }

    /**
     * Sends an invite link to an e-mail address.
     */
    async inviteUserRaw(requestParameters: ProjectApiInviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.inviteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sends an invite link to an e-mail address.
     */
    async inviteUser(requestParameters: ProjectApiInviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.inviteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectCentres without sending the request
     */
    async listProjectCentresRequestOpts(requestParameters: ProjectApiListProjectCentresRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectCentres().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/centres`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of project centres.
     */
    async listProjectCentresRaw(requestParameters: ProjectApiListProjectCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectCentreWithDomains>>> {
        const requestOptions = await this.listProjectCentresRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectCentreWithDomainsFromJSON));
    }

    /**
     * Returns list of project centres.
     */
    async listProjectCentres(requestParameters: ProjectApiListProjectCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectCentreWithDomains>> {
        const response = await this.listProjectCentresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectDomains without sending the request
     */
    async listProjectDomainsRequestOpts(requestParameters: ProjectApiListProjectDomainsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of project domains.
     */
    async listProjectDomainsRaw(requestParameters: ProjectApiListProjectDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectDomainWithStats>>> {
        const requestOptions = await this.listProjectDomainsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectDomainWithStatsFromJSON));
    }

    /**
     * Returns list of project domains.
     */
    async listProjectDomains(requestParameters: ProjectApiListProjectDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectDomainWithStats>> {
        const response = await this.listProjectDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectInvoices without sending the request
     */
    async listProjectInvoicesRequestOpts(requestParameters: ProjectApiListProjectInvoicesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startingAfter'] != null) {
            queryParameters['startingAfter'] = requestParameters['startingAfter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invoices`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the newest Stripe invoices for the project billing account.
     */
    async listProjectInvoicesRaw(requestParameters: ProjectApiListProjectInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceListData>> {
        const requestOptions = await this.listProjectInvoicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceListDataFromJSON(jsonValue));
    }

    /**
     * Get the newest Stripe invoices for the project billing account.
     */
    async listProjectInvoices(requestParameters: ProjectApiListProjectInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceListData> {
        const response = await this.listProjectInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannelCampaignData without sending the request
     */
    async marketingChannelCampaignDataRequestOpts(requestParameters: ProjectApiMarketingChannelCampaignDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        if (requestParameters['campaignRemoteId'] == null) {
            throw new runtime.RequiredError(
                'campaignRemoteId',
                'Required parameter "campaignRemoteId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/marketing-channel/{channelId}/campaign-detail/{campaignRemoteId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{channelId}', encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace('{campaignRemoteId}', encodeURIComponent(String(requestParameters['campaignRemoteId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns marketing channel campaign data.
     */
    async marketingChannelCampaignDataRaw(requestParameters: ProjectApiMarketingChannelCampaignDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleCampaignOverview>> {
        const requestOptions = await this.marketingChannelCampaignDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleCampaignOverviewFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel campaign data.
     */
    async marketingChannelCampaignData(requestParameters: ProjectApiMarketingChannelCampaignDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleCampaignOverview> {
        const response = await this.marketingChannelCampaignDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannelData without sending the request
     */
    async marketingChannelDataRequestOpts(requestParameters: ProjectApiMarketingChannelDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannelData().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling marketingChannelData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/marketing-channel/{channelId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{channelId}', encodeURIComponent(String(requestParameters['channelId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns marketing channel data.
     */
    async marketingChannelDataRaw(requestParameters: ProjectApiMarketingChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChannelOverview>> {
        const requestOptions = await this.marketingChannelDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChannelOverviewFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel data.
     */
    async marketingChannelData(requestParameters: ProjectApiMarketingChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChannelOverview> {
        const response = await this.marketingChannelDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannelOverviews without sending the request
     */
    async marketingChannelOverviewsRequestOpts(requestParameters: ProjectApiMarketingChannelOverviewsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannelOverviews().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/marketing-channel-overviews`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns all permitted channel overviews from one shared snapshot request.
     */
    async marketingChannelOverviewsRaw(requestParameters: ProjectApiMarketingChannelOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingChannelOverviewCollectionData>> {
        const requestOptions = await this.marketingChannelOverviewsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingChannelOverviewCollectionDataFromJSON(jsonValue));
    }

    /**
     * Returns all permitted channel overviews from one shared snapshot request.
     */
    async marketingChannelOverviews(requestParameters: ProjectApiMarketingChannelOverviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingChannelOverviewCollectionData> {
        const response = await this.marketingChannelOverviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannels without sending the request
     */
    async marketingChannelsRequestOpts(requestParameters: ProjectApiMarketingChannelsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/marketing-channels`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns marketing channel list.
     */
    async marketingChannelsRaw(requestParameters: ProjectApiMarketingChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingChannelList>> {
        const requestOptions = await this.marketingChannelsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingChannelListFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel list.
     */
    async marketingChannels(requestParameters: ProjectApiMarketingChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingChannelList> {
        const response = await this.marketingChannelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOrderStatusList without sending the request
     */
    async modifyOrderStatusListRequestOpts(requestParameters: ProjectApiModifyOrderStatusListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOrderStatusList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/order-status-list`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectStatusUpdateToJSON(requestParameters['projectStatusUpdate']),
        };
    }

    /**
     * Returns status list.
     */
    async modifyOrderStatusListRaw(requestParameters: ProjectApiModifyOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOrderStatusListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns status list.
     */
    async modifyOrderStatusList(requestParameters: ProjectApiModifyOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOrderStatusListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOtherSystemSource without sending the request
     */
    async modifyOtherSystemSourceRequestOpts(requestParameters: ProjectApiModifyOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/source/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ModifyOtherSystemSourceInputToJSON(requestParameters['modifyOtherSystemSourceInput']),
        };
    }

    /**
     * Modifies existing source.
     */
    async modifyOtherSystemSourceRaw(requestParameters: ProjectApiModifyOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Modifies existing source.
     */
    async modifyOtherSystemSource(requestParameters: ProjectApiModifyOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOtherSystemSourceInsights without sending the request
     */
    async modifyOtherSystemSourceInsightsRequestOpts(requestParameters: ProjectApiModifyOtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ModifyOtherSystemSourceInsightInputToJSON(requestParameters['modifyOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Modifies existing insight.
     */
    async modifyOtherSystemSourceInsightsRaw(requestParameters: ProjectApiModifyOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOtherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Modifies existing insight.
     */
    async modifyOtherSystemSourceInsights(requestParameters: ProjectApiModifyOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOtherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for newPaymentSetup without sending the request
     */
    async newPaymentSetupRequestOpts(requestParameters: ProjectApiNewPaymentSetupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling newPaymentSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/new-payment-setup`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * New payment setup.
     */
    async newPaymentSetupRaw(requestParameters: ProjectApiNewPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentSetupData>> {
        const requestOptions = await this.newPaymentSetupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSetupDataFromJSON(jsonValue));
    }

    /**
     * New payment setup.
     */
    async newPaymentSetup(requestParameters: ProjectApiNewPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentSetupData> {
        const response = await this.newPaymentSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderStatusList without sending the request
     */
    async orderStatusListRequestOpts(requestParameters: ProjectApiOrderStatusListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderStatusList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/order-status-list`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns status list.
     */
    async orderStatusListRaw(requestParameters: ProjectApiOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectOrderStatusSettings>> {
        const requestOptions = await this.orderStatusListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectOrderStatusSettingsFromJSON(jsonValue));
    }

    /**
     * Returns status list.
     */
    async orderStatusList(requestParameters: ProjectApiOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectOrderStatusSettings> {
        const response = await this.orderStatusListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for otherSystemSourceInsights without sending the request
     */
    async otherSystemSourceInsightsRequestOpts(requestParameters: ProjectApiOtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace('{otherSystemSourceId}', encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns other system source insights.
     */
    async otherSystemSourceInsightsRaw(requestParameters: ProjectApiOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherSystemSourceInsight>>> {
        const requestOptions = await this.otherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OtherSystemSourceInsightFromJSON));
    }

    /**
     * Returns other system source insights.
     */
    async otherSystemSourceInsights(requestParameters: ProjectApiOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherSystemSourceInsight>> {
        const response = await this.otherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for otherSystemSources without sending the request
     */
    async otherSystemSourcesRequestOpts(requestParameters: ProjectApiOtherSystemSourcesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling otherSystemSources().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling otherSystemSources().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{otherSystemType}', encodeURIComponent(String(requestParameters['otherSystemType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns other system sources by type.
     */
    async otherSystemSourcesRaw(requestParameters: ProjectApiOtherSystemSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherSystemSourceWithCentreAndDomain>>> {
        const requestOptions = await this.otherSystemSourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OtherSystemSourceWithCentreAndDomainFromJSON));
    }

    /**
     * Returns other system sources by type.
     */
    async otherSystemSources(requestParameters: ProjectApiOtherSystemSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherSystemSourceWithCentreAndDomain>> {
        const response = await this.otherSystemSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchProjectRole without sending the request
     */
    async patchProjectRoleRequestOpts(requestParameters: ProjectApiPatchProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling patchProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling patchProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchRoleInputToJSON(requestParameters['patchRoleInput']),
        };
    }

    /**
     * Patches a role.
     */
    async patchProjectRoleRaw(requestParameters: ProjectApiPatchProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.patchProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Patches a role.
     */
    async patchProjectRole(requestParameters: ProjectApiPatchProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.patchProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectInvites without sending the request
     */
    async projectInvitesRequestOpts(requestParameters: ProjectApiProjectInvitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectInvites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invites`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all the invites available on this project.
     */
    async projectInvitesRaw(requestParameters: ProjectApiProjectInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectInvitation>>> {
        const requestOptions = await this.projectInvitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectInvitationFromJSON));
    }

    /**
     * Returns all the invites available on this project.
     */
    async projectInvites(requestParameters: ProjectApiProjectInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectInvitation>> {
        const response = await this.projectInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectRoles without sending the request
     */
    async projectRolesRequestOpts(requestParameters: ProjectApiProjectRolesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/roles`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns project roles.
     */
    async projectRolesRaw(requestParameters: ProjectApiProjectRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectRole>>> {
        const requestOptions = await this.projectRolesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectRoleFromJSON));
    }

    /**
     * Returns project roles.
     */
    async projectRoles(requestParameters: ProjectApiProjectRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectRole>> {
        const response = await this.projectRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectStatus without sending the request
     */
    async projectStatusRequestOpts(requestParameters: ProjectApiProjectStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/status`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns quick info about the state of project update.
     */
    async projectStatusRaw(requestParameters: ProjectApiProjectStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectRuntimeOverview>> {
        const requestOptions = await this.projectStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectRuntimeOverviewFromJSON(jsonValue));
    }

    /**
     * Returns quick info about the state of project update.
     */
    async projectStatus(requestParameters: ProjectApiProjectStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectRuntimeOverview> {
        const response = await this.projectStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectUsers without sending the request
     */
    async projectUsersRequestOpts(requestParameters: ProjectApiProjectUsersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/users`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists users by project.
     */
    async projectUsersRaw(requestParameters: ProjectApiProjectUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectUsers200Response>> {
        const requestOptions = await this.projectUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Lists users by project.
     */
    async projectUsers(requestParameters: ProjectApiProjectUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectUsers200Response> {
        const response = await this.projectUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeProjectUser without sending the request
     */
    async removeProjectUserRequestOpts(requestParameters: ProjectApiRemoveProjectUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling removeProjectUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/users`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveUserInputToJSON(requestParameters['removeUserInput']),
        };
    }

    /**
     * Revokes access to the user.  Only owner can remove users.
     */
    async removeProjectUserRaw(requestParameters: ProjectApiRemoveProjectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeProjectUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Revokes access to the user.  Only owner can remove users.
     */
    async removeProjectUser(requestParameters: ProjectApiRemoveProjectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeProjectUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resendProjectInvite without sending the request
     */
    async resendProjectInviteRequestOpts(requestParameters: ProjectApiResendProjectInviteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling resendProjectInvite().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling resendProjectInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invite/{inviteId}/resend`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{inviteId}', encodeURIComponent(String(requestParameters['inviteId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resends an existing project invitation without creating another invitation.
     */
    async resendProjectInviteRaw(requestParameters: ProjectApiResendProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.resendProjectInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resends an existing project invitation without creating another invitation.
     */
    async resendProjectInvite(requestParameters: ProjectApiResendProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resendProjectInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setProjectBillingAccount without sending the request
     */
    async setProjectBillingAccountRequestOpts(requestParameters: ProjectApiSetProjectBillingAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling setProjectBillingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/set-billing-account`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectBillingAccountInputToJSON(requestParameters['projectBillingAccountInput']),
        };
    }

    /**
     * Updates the project billing account.
     */
    async setProjectBillingAccountRaw(requestParameters: ProjectApiSetProjectBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.setProjectBillingAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Updates the project billing account.
     */
    async setProjectBillingAccount(requestParameters: ProjectApiSetProjectBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.setProjectBillingAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for touchProject without sending the request
     */
    async touchProjectRequestOpts(requestParameters: ProjectApiTouchProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling touchProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/touch`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Updates the project last interaction to move it higher in the list.
     */
    async touchProjectRaw(requestParameters: ProjectApiTouchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.touchProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates the project last interaction to move it higher in the list.
     */
    async touchProject(requestParameters: ProjectApiTouchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.touchProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProject without sending the request
     */
    async updateProjectRequestOpts(requestParameters: ProjectApiUpdateProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectInputToJSON(requestParameters['projectInput']),
        };
    }

    /**
     * Defined values will be changed for the project, other undefined  will stay the same.
     */
    async updateProjectRaw(requestParameters: ProjectApiUpdateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.updateProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Defined values will be changed for the project, other undefined  will stay the same.
     */
    async updateProject(requestParameters: ProjectApiUpdateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.updateProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectDomainsStatus without sending the request
     */
    async updateProjectDomainsStatusRequestOpts(requestParameters: ProjectApiUpdateProjectDomainsStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectDomainsStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains/status`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOrUpdateProjectDomainInput']!.map(CreateOrUpdateProjectDomainInputToJSON),
        };
    }

    /**
     * Updates multiple project domains status at once.
     */
    async updateProjectDomainsStatusRaw(requestParameters: ProjectApiUpdateProjectDomainsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateProjectDomainsStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates multiple project domains status at once.
     */
    async updateProjectDomainsStatus(requestParameters: ProjectApiUpdateProjectDomainsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateProjectDomainsStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectOwner without sending the request
     */
    async updateProjectOwnerRequestOpts(requestParameters: ProjectApiUpdateProjectOwnerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectOwner().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateProjectOwner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/{userId}/set-owner`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetOwnerInputToJSON(requestParameters['setOwnerInput']),
        };
    }

    /**
     * Updates project owner.
     */
    async updateProjectOwnerRaw(requestParameters: ProjectApiUpdateProjectOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.updateProjectOwnerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates project owner.
     */
    async updateProjectOwner(requestParameters: ProjectApiUpdateProjectOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.updateProjectOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectRole without sending the request
     */
    async updateProjectRoleRequestOpts(requestParameters: ProjectApiUpdateProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectRole().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/{userId}/set-role`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetRoleInputToJSON(requestParameters['setRoleInput']),
        };
    }

    /**
     * Updates project role.
     */
    async updateProjectRoleRaw(requestParameters: ProjectApiUpdateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.updateProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates project role.
     */
    async updateProjectRole(requestParameters: ProjectApiUpdateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.updateProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLogo without sending the request
     */
    async uploadLogoRequestOpts(requestParameters: ProjectApiUploadLogoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling uploadLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['logo'] != null) {
            formParams.append('logo', requestParameters['logo'] as any);
        }


        let urlPath = `/api/v1/project/{projectId}/logo`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Users with `ProjectProfile` permission can do this action.
     */
    async uploadLogoRaw(requestParameters: ProjectApiUploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.uploadLogoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Users with `ProjectProfile` permission can do this action.
     */
    async uploadLogo(requestParameters: ProjectApiUploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.uploadLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ProjectUsersPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ProjectUsersPageSizeEnum = typeof ProjectUsersPageSizeEnum[keyof typeof ProjectUsersPageSizeEnum];
/**
 * @export
 */
export const ProjectUsersSortByEnum = {
    User: 'user',
    IsOwner: 'isOwner',
    Role: 'role',
    Email: 'email',
    LastInteraction: 'lastInteraction'
} as const;
export type ProjectUsersSortByEnum = typeof ProjectUsersSortByEnum[keyof typeof ProjectUsersSortByEnum];
/**
 * @export
 */
export const ProjectUsersSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ProjectUsersSortDirectionEnum = typeof ProjectUsersSortDirectionEnum[keyof typeof ProjectUsersSortDirectionEnum];
